import { render, staticRenderFns } from "./HeroManager.vue?vue&type=template&id=12966d77&"
import script from "./HeroManager.vue?vue&type=script&lang=js&"
export * from "./HeroManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports